module.exports = __webpack_public_path__ + "static/media/website_icon.06833d37.png";